import { useMemo, useState } from 'react';

interface useCanSubmit {
  canSubmit: boolean;
  setDisableSubmit: React.Dispatch<React.SetStateAction<boolean>>;
}

export const useCanSubmit = (isSubmitting: boolean, isLoading: boolean): useCanSubmit => {
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const canSubmit = useMemo(
    () => !isSubmitting && !isLoading && !disableSubmit,
    [isSubmitting, isLoading, disableSubmit],
  );

  return {
    canSubmit,
    setDisableSubmit,
  };
};
